import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'fgbcl-counter',
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss',
})
export class CounterComponent implements OnInit {
  @Input() count: number = 0;

  /** Emitted Count Value. */
  @Output() countEmitter = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.count) {
      this.count = 0;
    }
  }

  /** will do increment in count. */
  increment() {
    this.count++;
    this.countEmitter.emit(this.count);
  }

  /** will do decrement in count. */
  decrement() {
    if (this.count > 0) {
      this.count--;
      this.countEmitter.emit(this.count);
    }
  }

  onInput(event: any) {
    const value = parseInt(event.target.value, 10);
    this.count = isNaN(value) ? 0 : value;
    this.countEmitter.emit(this.count);
  }

  /** will do prevent Invalid Input. */
  preventInvalidInput(event: KeyboardEvent) {
    // Prevent 'e', '+', '-', and any non-numeric characters
    if (['e', 'E', '+', '-', '.'].includes(event.key) || (event.key.length === 1 && !/\d/.test(event.key))) {
      event.preventDefault();
    }
  }
}
